

exports.__esModule = true;
exports.TOKEN_PARAM_NAME = undefined;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _checkout = require('xo-models/src/checkout');

var _auth = require('xo-models/src/auth');

var _venmoModels = require('xo-venmo-components/src/venmo-models');

var _venmoInfo = require('xo-venmo-components/src/venmo-info');

var _uiRouter = require('uiRouter');

var TOKEN_PARAM_NAME = exports.TOKEN_PARAM_NAME = 'payload_id';

exports['default'] = _squid.$Component.extend('$VenmoPayloadBootstrap', {
    tag: 'venmo-payload-bootstrap',
    template: '<div>', // Empty template

    props: {
        token: {
            type: 'var',
            optional: false
        }
    },

    resolve: {
        venmoParams: function venmoParams() {
            var _ref;

            return _ref = {}, _ref[TOKEN_PARAM_NAME] = _uiRouter.$stateParams[TOKEN_PARAM_NAME], _ref;
        },
        checkoutCart: function checkoutCart() {
            return _checkout.$CheckoutCartModel.instance(this.token);
        }
    },

    lifecycle: {
        enter: function enter() {
            _logger.$logger.info(['xo-venmo directive', 'lifecycle', 'enter'].join('::'));
        },
        populate: function populate() {
            var _this = this;

            var venmoParams = this.venmoParams,
                checkoutCart = this.checkoutCart;

            var checkoutSessionModel = _checkout.$CheckoutSessionModel.instance(this.token);
            var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(this.token);
            var appData = _checkout.$CheckoutAppDataModel.instance(this.token);
            var payee = _checkout.$CheckoutPayeeModel.instance(this.token);
            var venmoDcvv = void 0;

            var totalTransaction = checkoutCart && checkoutCart.purchase && checkoutCart.purchase.amounts && checkoutCart.purchase.amounts.total;

            venmoParams.limit = {
                currency: totalTransaction.currency_code,
                amount: totalTransaction.amount
            };

            venmoParams.merchant_id = payee.merchant.id;

            // define steps
            var onboardMember = function onboardMember() {
                return venmoOnboardModel.save({
                    data: venmoParams,
                    success: function success(data) {
                        _logger.$logger.info(data);
                        venmoDcvv = data.dcvv;
                        return data;
                    },
                    error: function error(err) {
                        _logger.$logger.info(err);
                        _uiRouter.$state.go('checkout.login');
                    },
                    validation: function validation(_validation) {
                        return _uiRouter.$state.go('checkout.login');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _uiRouter.$state.go('checkout.login');
                            _logger.$logger.error(msg);
                            _logger.$logger.error(contingency);
                        }
                    }
                });
            };
            var setVenmoToken = function setVenmoToken() {
                return _venmoInfo.venmoExperience.set(_this.token);
            };
            var createCheckoutSession = function createCheckoutSession() {
                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token,
                        user_selected_funding_source: {
                            dcvv: venmoDcvv,
                            product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                        }
                    },
                    success: function success(result) {
                        return result;
                    }
                });
            };
            var refreshAuthState = function refreshAuthState() {
                return _auth.$AuthModel.instance().reload();
            };

            var onAuth = function onAuth(authModel) {

                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {

                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var routeDecision = function routeDecision(checkoutSession) {

                // if shipping is required and no shipping is sent in xo session, we route to shipping address page
                if (appData.get('flags.shipping_address_required') && !checkoutSession.shipping) {

                    return _uiRouter.$state.go('checkout.pageAddShipping.addShipping');
                }

                // else, we go to review page.
                return _uiRouter.$state.go('checkout.review');
            };

            onboardMember().then(setVenmoToken).then(refreshAuthState).then(onAuth).then(createCheckoutSession).then(routeDecision)['catch'](function (err) {
                _logger.$logger.error(err && err.stack || err);
                venmoOnboardModel.invalidate();
                _uiRouter.$state.go('checkout.login');
            });
        }
    }
});


_squid.$Component;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_auth.$AuthModel;

_venmoModels.$VenmoOnboardModel;

_venmoInfo.venmoExperience;

_uiRouter.$stateParams;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-venmo/directive.js
// module id = ./pages/xo-venmo/directive.js
// module chunks = 1